import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { GuiToolsService } from '../../services/shared/gui-tools.service';
import Swal from 'sweetalert2';
import { Translators } from 'src/app/services/shared/translators.service';
import { APP_CONFIG, IAppConfig } from '../../app.config/app.config';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { MatDialog } from '@angular/material/dialog';
import { TermsConditions } from './terms-conditions/terms-conditions.component';
import { ConfirmarDatosRegistroComponent, ConfirmarDatosRegistroData } from './confirmar-datos-registro/confirmar-datos-registro.component';
import { Register } from 'src/app/interfaces/interface-frontend/register';
import { Catalogo } from 'src/app/interfaces/interface-bakend/shared/catalogo/catalogo.interface';
import { OpenPageService } from '../../services/shared/open-page.service';

// import { GecrosAfiliadosService } from 'src/app/services/entidades/gecros-afiliados.service';
// import { SignoGecrosAfiliado } from 'src/app/interfaces/interface-bakend/entidades/signo-greco-afiliado.interface';
// import { UsuarioService } from '../../services/shared/usuario.service';

//Beneficios
import { SidefiAfiliadosService } from '@services/sidefi/sidefi.service';
import { SidefiResponse, ConsultaSidefiResponse } from '@interfaces/sidefi/sidefi.interface';

@Component({
    selector: 'app-profile-authentication',
    templateUrl: './profile-authentication.component.html',
    styleUrls: ['./profile-authentication.component.scss'],
})

export class ProfileAuthenticationComponent implements OnInit {
    loginForm: FormGroup;
    registerForm: FormGroup;
    loadingForm = false;
    loading: Subscription;
    fieldTextType: boolean;
    idioma: Subscription;
    siteKey: string;
    showPasswordLogin: boolean;
    showPasswordRegister: boolean;
    showPasswordConfirm: boolean;
    concepto: string;
    check: boolean = false;
    flagLoadedModal = true;
    flagLoaded = false;
    flagPreCarga = false;
    flagExisteIdentificacion = false;
    selectedTipoIdentificacion: Catalogo;
    flagFormaValido = false;

    sedeSidefi: string;

    // INICIO: Cambios en las propiedades del componente
    // REMOVIDO: Banderas y datos específicos de Gecros
    // flagDataGecros: boolean = false;
    // flagControlPrestaciones: boolean = false;
    // flagMenorEdad: boolean = false;
    // flagTitular: boolean = false;

    // NUEVO: Bandera y datos para Sidefi
    public flagDataEncontrada: boolean = false; // Indica si se encontraron datos en Sidefi
    public dataSidefi: SidefiResponse | null = null; // Almacena la respuesta completa de Sidefi
    public fechaAfiliadoMT: string | null = null; // Para almacenar fecAfiliadoMT de Sidefi
    public fechaAfiliadoSD: string | null = null; // Para almacenar fecAfiliadoSD de Sidefi
    public fechaAfiliadoOS: string | null = null; // Para almacenar fecAfiliadoOS de Sidefi

    idPasaporte: string;
    isDisabled: boolean = true;
    identificacion: string = "";
    // REMOVIDO: Propiedades de Gecros
    // dataGecros: SignoGecrosAfiliado = undefined;
    email: any;
    // REMOVIDO: Propiedades de Gecros
    // afiliadoGecrosNombre: string = "";
    // signoSedeCodigo: string;
    // signoPlan: string;
    seleccionado: boolean;

    showTimeoutMessage: boolean = false;
    viewSpinner: boolean = false;
    searchTimeout: any;
    // FIN: Cambios en las propiedades del componente

    constructor(
        private authservice: AuthService,
        private guiToolsService: GuiToolsService,
        private translatorService: Translators,
        @Inject(APP_CONFIG) private iAppConfig: IAppConfig,
        public guiMsjService: GuiMsjService,
        public dialog: MatDialog,
        private openPageService: OpenPageService,
        private zone: NgZone,
        private sidefiAfiliadosService: SidefiAfiliadosService,
        private router: Router
    ) {
        this.loading = this.guiToolsService.getLoading().subscribe(resp => {
            this.loadingForm = resp;
        });

        // this.idioma = this.translatorService.getIdiomaSeleccionado().subscribe(resp => {
        //     this.idioma = resp;
        // });

        this.createforms();
    }

    async ngOnInit() {
        this.setSiteKey(this.iAppConfig.recaptcha.siteKey);
        this.setIdPasaporte(this.iAppConfig.dniid);
        await this.authservice.getCheck$().subscribe((acepta: boolean) => {
            this.check = acepta;
        });

        this.createListenersStateForm();
    }

    setSiteKey(key: string) {
        this.siteKey = key;
    }

    setIdPasaporte(id: string) {
        this.idPasaporte = id;
    }

    useLanguage(idioma: string) {
        this.translatorService.setIdiomaSeleccionado(idioma);
    }

    toggleFieldTextType() {
        this.fieldTextType = !this.fieldTextType;
    }

    get emailAccess() {
        return this.loginForm.get('email').invalid && this.loginForm.get('email').touched;
    }

    get passwordAccess() {
        return this.loginForm.get('password').invalid && this.loginForm.get('password').touched;
    }

    get emailNoValido() {
        const emailControl = this.registerForm.get('email');
        const emailValue = emailControl.value;
        const emailPattern = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
        // El email ahora siempre se valida como entrada manual
        return !emailControl.valid && emailControl.touched && !emailPattern.test(emailValue);
    }

    get passwordNoValido() {
        return this.registerForm.get('password').invalid && this.registerForm.get('password').touched;
    }

    get confirmPasswordNoValido() {
        const pass1 = this.registerForm.get('password').value;
        const pass2 = this.registerForm.get('confirmPassword').value;
        return (pass1 === pass2) ? false : true;
    }

    get confirmEmailNoValido() {
        const email1 = this.registerForm.get('email').value;
        const email2 = this.registerForm.get('confirmEmail').value;
        return (email1 === email2) ? false : true;
    }

    get getNombreNoValido() {
        return this.registerForm.get('nombrePersona').invalid && this.registerForm.get('nombrePersona').touched;
    }

    get getApellidoNoValido() {
        return this.registerForm.get('apellidoPersona').invalid && this.registerForm.get('apellidoPersona').touched;
    }

    get getIdentificacionNoValida() {
        return this.registerForm.get('identificacion').invalid && this.registerForm.get('identificacion').touched;
    }

    get getTelefonoNoValido() {
        return this.registerForm.get('telefono').invalid && this.registerForm.get('telefono').touched;
    }


    async login() {
        if (this.loginForm.invalid) {
            return Object.values(this.loginForm.controls).forEach(control => {
                control.markAsTouched();
            });
        }

        this.authservice.login(
            this.loginForm.value.email,
            this.loginForm.value.password
        );

        await this.guiMsjService.msjFormSubmit('Espere');
        Swal.showLoading();
    }

    createListenersStateForm() {
        this.registerForm.get('email')?.valueChanges.subscribe(() => {
            this.registerForm.get('confirmEmail')?.reset();
        });

        return this.registerForm.statusChanges.subscribe(async status => {
            // INICIO: Lógica de validación del formulario adaptada para Sidefi
            // REMOVIDO: Las flags de Gecros
            // if (status === 'VALID' && this.flagDataGecros && this.flagControlPrestaciones && this.flagTitular) {
            // NUEVO: Se basa en la validez del formulario y si se encontraron datos en Sidefi
            if (status === 'VALID' && this.flagDataEncontrada) {
                this.flagFormaValido = true;
            } else {
                this.flagFormaValido = false;
            }
            // FIN: Lógica de validación del formulario
        });
    }

    async registerUser() {
        if (this.registerForm.invalid) {
            return Object.values(this.registerForm.controls).forEach(control => {
                control.markAsTouched();
            });
        }

        const data = await this.setDataForma();

        const confirmado = await this.confirmarDatosRegistro(data);
        if (!confirmado) {
            return;
        }

        await this.guiMsjService.msjFormSubmit('Espere');
        Swal.showLoading();
        
        const success = await this.authservice.registerUser(data);
        if (success) {
            this.registerForm.reset();
            this.flagFormaValido = false;
            this.flagExisteIdentificacion = false;
            this.router.navigate(['/descarga-redirect']);
        }
    }

    async confirmarDatosRegistro(data: Register): Promise<boolean> {
        const dialogData: ConfirmarDatosRegistroData = {
            nombrePersona: data.nombrePersona,
            apellidoPersona: data.apellidoPersona,
            identificacion: data.identificacion,
            telefono: data.telefono,
            email: data.email,
        };

        const dialogRef = this.dialog.open(ConfirmarDatosRegistroComponent, {
            width: '500px',
            disableClose: true,
            data: dialogData,
        });

        return dialogRef.afterClosed().toPromise();
    }

    inputSeleccionado() {
        this.seleccionado = true;
    }

    async setDataForma(): Promise<Register> {
        const data: Register = {
            nombrePersona: this.registerForm.value.nombrePersona,
            apellidoPersona: this.registerForm.value.apellidoPersona,
            tipoIdentificacion: this.idPasaporte,
            identificacion: this.registerForm.value.identificacion,
            telefono: this.registerForm.value.telefono,
            email: this.registerForm.value.email,
            emailConfirm: this.registerForm.value.confirmEmail,
            password: this.registerForm.value.password,
            passwordConfirm: this.registerForm.value.confirmPassword,
            aceptaTerminos: this.registerForm.value.aceptaTerminos,
            proteccionDeDatos: this.registerForm.value.proteccionDeDatos,
            clausula: this.registerForm.value.clausula,
            codigoSidefi: this.sedeSidefi,
            fromWeb: true,
            fromApp: false,
            // REMOVIDO: Propiedades de Gecros en el objeto Register
            // signoGecrosAfiliado: this.dataGecros,
            // signoPlan: this.signoPlan != undefined ? this.signoPlan : null,
            // codigoGecros: this.signoSedeCodigo != undefined ? this.signoSedeCodigo : null,
            notifica: true
        };

        // INICIO: Si el backend espera los datos de Sidefi en el objeto Register
        // Si necesitamos enviar las fechas de afiliación de Sidefi al backend,
        // hay que extender la interfaz 'Register' para incluir estos campos
        // y luego asignarlos aquí:
        // if (this.fechaAfiliadoMT) { (data as any).fecAfiliadoMT = this.fechaAfiliadoMT; }
        // if (this.fechaAfiliadoSD) { (data as any).fecAfiliadoSD = this.fechaAfiliadoSD; }
        // if (this.fechaAfiliadoOS) { (data as any).fecAfiliadoOS = this.fechaAfiliadoOS; }
        // FIN: Si el backend espera los datos de Sidefi

        return data;
    }

    // CREACION DE FORMULARIOS
    async createforms() {
        this.createFormLogin();
        this.createFormRegister();
        this.flagLoaded = true;
    }

    createFormLogin() {
        this.loginForm = new FormGroup({
            email: new FormControl('', [Validators.required,]),
            password: new FormControl('', [Validators.required, Validators.minLength(8)]),
        });
    }

    // INICIO: Función para buscar afiliado, ahora con Sidefi
    // RENOMBRADO: De buscarAfiliadoGecros a buscarAfiliadoSidefi
    async buscarAfiliadoSidefi() {
        if (this.identificacion && this.identificacion.trim() !== '') {
            this.viewSpinner = true;
            this.showTimeoutMessage = false;

            // Asegurarse de limpiar cualquier timeout anterior
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Configurar el timeout para el mensaje de "no encontrado"
            this.searchTimeout = new Promise<void>((_, reject) => {
                setTimeout(() => {
                    this.zone.run(() => {
                        this.showTimeoutMessage = true; // Mostrar mensaje de "no encontrado"
                    });
                    reject(new Error('Timeout de búsqueda')); // Rechazar la promesa del timeout
                }, 3000);
            });

            try {
                // REMOVIDO: Simulación de respuesta de Gecros
                // const mockResponse = { ... };
                // const resp = await Promise.race([Promise.resolve(mockResponse), this.searchTimeout]);

                // NUEVO: Llamada al servicio de Sidefi usando .toPromise()
                // Usamos Promise.race para manejar el timeout
                const resp = await Promise.race([
                    this.sidefiAfiliadosService.consultarAfiliacionSidefi(this.identificacion),
                    this.searchTimeout
                ]);

                // PROCESAMIENTO DE LA RESPUESTA DE SIDEFI
                // Sidefi devuelve { response: { nombre: "...", fecAfiliadoMT: "...", ... } }
                if (resp && resp.nombre) { // Verificamos que 'resp' no sea null y que 'nombre' exista dentro de la respuesta de Sidefi
                    const nombreCompleto: string = resp.nombre.trim();
                    let nombrePersona = '';
                    let apellidoPersona = '';

                    // Lógica para separar nombre y apellido del campo 'nombre' de Sidefi
                    const partesNombre = nombreCompleto.split(/\s+/);
                    if (partesNombre.length > 1) {
                        apellidoPersona = partesNombre[partesNombre.length - 1]; // Última palabra como apellido
                        nombrePersona = partesNombre.slice(0, partesNombre.length - 1).join(' '); // El resto como nombre
                    } else {
                        nombrePersona = nombreCompleto; // Si solo hay una palabra, se usa como nombre
                    }

                    this.flagDataEncontrada = true; // Indicar que se encontraron datos en Sidefi
                    this.dataSidefi = resp; // Guardar la respuesta completa de Sidefi

                    // Almacenar las fechas de afiliación si son necesarias en el componente
                    this.fechaAfiliadoMT = resp.fecAfiliadoMT;
                    this.fechaAfiliadoSD = resp.fecAfiliadoSD;
                    this.fechaAfiliadoOS = resp.fecAfiliadoOS;

                    //sedeSidefi
                    this.sedeSidefi = resp.sedeAfiliado;

                    // Rellenar campos del formulario
                    this.registerForm.controls['nombrePersona'].setValue(nombrePersona);
                    this.registerForm.controls['apellidoPersona'].setValue(apellidoPersona);
                    // Los campos de email y confirmEmail NO se pre-llenan con Sidefi
                    this.registerForm.controls['email'].setValue(null);
                    this.registerForm.controls['confirmEmail'].setValue(null);
                    // Asegúrate de limpiar el mensaje de timeout si la búsqueda fue exitosa
                    this.showTimeoutMessage = false;

                } else {
                    // Si no se encuentran datos de Sidefi o la respuesta es vacía/inválida
                    this.flagDataEncontrada = false;
                    this.dataSidefi = null; // Limpiar los datos de Sidefi
                    this.fechaAfiliadoMT = null;
                    this.fechaAfiliadoSD = null;
                    this.fechaAfiliadoOS = null;

                    // Limpiar campos del formulario si no se encontraron datos
                    this.registerForm.controls['nombrePersona'].setValue(null);
                    this.registerForm.controls['apellidoPersona'].setValue(null);
                    this.registerForm.controls['email'].setValue(null);
                    this.registerForm.controls['confirmEmail'].setValue(null);

                    // REMOVIDO: Limpiar banderas y propiedades de Gecros
                    // this.flagTitular = false;
                    // this.dataGecros = undefined;
                    // this.signoSedeCodigo = null;
                    // this.signoPlan = null;

                    this.showTimeoutMessage = true; // Mostrar mensaje de "no encontrado"
                }
            } catch (error) {
                console.error("Error al buscar afiliado en Sidefi (o timeout):", error);
                this.showTimeoutMessage = true; // Mostrar mensaje de error/timeout
            } finally {
                // Asegurar que el timeout se limpie y el spinner se oculte
                if (this.searchTimeout) {
                    clearTimeout(this.searchTimeout);
                }
                this.viewSpinner = false;
            }
        } else {
            // Si el DNI está vacío, ocultar el spinner
            this.viewSpinner = false;
            this.showTimeoutMessage = false; // Ocultar mensaje si el campo está vacío
            // Limpiar datos y campos si el DNI se vacía
            this.flagDataEncontrada = false;
            this.dataSidefi = null;
            this.fechaAfiliadoMT = null;
            this.fechaAfiliadoSD = null;
            this.fechaAfiliadoOS = null;
            this.registerForm.controls['nombrePersona'].setValue(null);
            this.registerForm.controls['apellidoPersona'].setValue(null);
            this.registerForm.controls['email'].setValue(null);
            this.registerForm.controls['confirmEmail'].setValue(null);
        }
    }
    // FIN: Función para buscar afiliado

    // REMOVIDO: Funciones específicas de Gecros
    // controlPrestaciones(afiliado) { ... }
    // tieneAlMenos18Anios(afiliado): boolean { ... }

    createFormRegister() {
        this.registerForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),]),
            confirmEmail: new FormControl('', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),]),
            password: new FormControl('', [Validators.required, Validators.pattern(/^.{8}$/)]),
            confirmPassword: new FormControl('', [Validators.required, Validators.pattern(/^.{8}$/)]),
            // Nombre y Apellido se pre-llenan si Sidefi los trae, pero pueden ser modificados o requeridos si no se encuentran
            nombrePersona: new FormControl('', [Validators.required, Validators.minLength(3)]),
            apellidoPersona: new FormControl('', [Validators.required, Validators.minLength(3)]),
            identificacion: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(15)]),
            telefono: new FormControl('', [Validators.required, Validators.pattern(/^\+?(?:54)?[ -]?(?:9|15)?[ -]?\d{2,4}[ -]?\d{6,8}$/)]),
            aceptaTerminos: new FormControl('', Validators.requiredTrue),
            proteccionDeDatos: new FormControl('', Validators.requiredTrue),
            clausula: new FormControl(false),
            recaptcha: new FormControl('', Validators.required)
        });

        // Añadir listener para el campo de identificación para activar la búsqueda de Sidefi
        this.registerForm.controls['identificacion'].valueChanges.subscribe(value => {
            this.identificacion = value; // Actualiza la propiedad 'identificacion' del componente
            this.buscarAfiliadoSidefi(); // Llama a la función de búsqueda cada vez que el DNI cambia
        });
    }

    verTerminos() {
        this.openDialog();
    }

    openDialog() {
        const dialogRef = this.dialog.open(TermsConditions, {
            width: '900px',
            height: '800px',
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe(async result => { });
        return;
    }

    openBlank(type: string) {
        this.openPageService.openBlank(type);
    }
}
